import snackbarObject from 'store/Constants/UI/SnackbarTypes';

export const snackbarError = (msgtxt) => ({
  type: snackbarObject.SNACKBAR_ERROR,
  payload: {
    message: msgtxt,
  },
});

export const snackbarClose = () => ({
  type: snackbarObject.SNACKBAR_CLOSE,
  payload: {
    message: '',
    display: false,
  },
});
